/** In-memory bridge so AuthContext can push D1 UI prefs into Language/Theme providers. */
const listeners = new Set();

export function subscribeUiPreferences(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function applyUiPreferences(prefs) {
  if (!prefs) return;
  listeners.forEach((fn) => {
    try {
      fn(prefs);
    } catch (e) {
      console.warn('uiPreferences listener error:', e);
    }
  });
}
